<div class="layout-wrapper" [ngClass]="{'layout-menu-horizontal': app.menuMode === 'horizontal',
                                        'layout-menu-overlay': app.menuMode === 'overlay',
                                        'layout-menu-static': app.menuMode === 'static',
                                        'layout-menu-slim': app.menuMode === 'slim',
                                        'layout-menu-light': true,
                                        'layout-menu-overlay-active': overlayMenuActive,
                                        'layout-menu-mobile-active': staticMenuMobileActive || overlayMenuActive,
                                        'layout-menu-static-inactive': staticMenuDesktopInactive,
                                        'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple}"
    [class.cm-lateral-recolhida]="menuLateralNovo && menuLateralRecolhido" (click)="onLayoutClick()">
    <!-- <div class="p-d-lg-none">
        <app-topbar></app-topbar>
    </div> -->
    

    <!-- <app-rightpanel></app-rightpanel> -->

    <app-menu #appMenu></app-menu>

    <div class="layout-main">
        <nav class="cm-abas p-d-none p-d-md-flex" aria-label="Telas abertas">
            <div *ngFor="let aba of abas; trackBy: chaveDaAba"
                class="cm-aba"
                [class.cm-aba-ativa]="aba.chave === abaAtiva"
                [title]="aba.titulo"
                role="link"
                tabindex="0"
                (click)="abrirAba(aba)"
                (keydown.enter)="abrirAba(aba)">
                <i [class]="aba.icone"></i>
                <span class="cm-aba-titulo">{{aba.titulo}}</span>
                <button *ngIf="aba.chave !== abaInicial"
                    type="button"
                    class="cm-aba-fechar"
                    title="Fechar"
                    aria-label="Fechar aba"
                    (click)="fecharAba(aba, $event)">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </nav>
        <!-- <div class="p-d-lg-none" style="height: 60px">
        </div> -->
        <div class="p-d-none p-d-md-block">
          <div id="acoes-rapidas" style="margin-bottom: 12px;"></div>
        </div>
        <app-breadcrumb></app-breadcrumb>

        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>

        <!-- <app-footer></app-footer> -->
    </div>

    <!-- <app-config></app-config> -->
</div>
